import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import App from "./app/App";
import reportWebVitals from "./reportWebVitals";
import { store } from "./store/store";
import "./styles/_index.scss";
import "./utils/function/sidebarToggle";
// console.log = console.warn = console.error = () => {}; // console clear
ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>,
  document.getElementById("root")
);
reportWebVitals();
